// extracted by mini-css-extract-plugin
module.exports = {"root":"ViewSelect_root__3u7WR"};